import React, { useState, useEffect } from "react";
import { Icon, Card, Row, Col, Tooltip } from "antd";
import moment from "moment";
import Table from "../../components/table";
import Search from "../../components/table/search";
import SearchDates from "../../components/table/searchDates";
import RenderFigureData from "../../components/render-figure-data";
import EjeFinal from "../../img/Eje-Final.jpg"
import RuedaFinal from "../../img/Rueda-Final.jpg"
import ArticleModal from "./articleModal";
import Articulo from "../articulo";
import useDesings from "../../hooks/useDesings";
import { useTranslation } from 'react-i18next'

const ListArticles = ({ changeTitle }) => {
  const [listOfArticles, setListOfArticles] = useState([]);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [edit, setEdit] = useState(false);
  const [editDesingEl] = useState({});
  const { desings, getArticlesWithDesings } = useDesings();
  const [showModalArticle, setShowModalArticle] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    changeTitle && !edit && changeTitle("articles");
  }, [changeTitle, edit]);

  useEffect(() => {
    const normalized = desings.map(article => {
      return {
        key: article.id,
        inUse: getArticlesWithDesings().includes(article.id),
        ...article
      };
    });
    normalized && setListOfArticles(normalized);
    if (normalized && normalized[0]) {
      setSelectedArticle(normalized[0]);
      setSelectedRowKey([normalized[0].key]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [desings]);

  const columns = [
    {
      title: t('table.header.name'),
      dataIndex: "articleName",
      key: "articleName",
      sorter: (a, b) => a.articleName.localeCompare(b.articleName),
      defaultSortOrder: "descend",
      ...Search("articleName")
    },
    {
      title: t('table.header.geometryFin'),
      dataIndex: "geometriaFinal",
      key: "geometriaFinal",
      sorter: (a, b) => a.geometriaFinal.localeCompare(b.geometriaFinal),
      defaultSortOrder: "descend",
      ...Search("geometriaFinal")
    },
    {
      title: t('table.header.article_date'),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => moment(a.date).unix() - moment(b.date).unix(),
      ...SearchDates("date"),
      render: date => moment(date).format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t('table.header.actions'),
      key: "action",
      width: 140,
      render: (text, record) => (
        <Row type="flex" justify="space-between">
          <Tooltip>
            <Icon type="diff" style={{ color: "#ccc" }}/>
          </Tooltip>

          <Tooltip>
            <Icon type="edit" style={{ color: "#ccc" }}/>
          </Tooltip>

          <Tooltip>
            <Icon type="delete" style={{ color: "#ccc" }}/>
          </Tooltip>
        </Row>
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
    },
    onSelect: (record, selected, selectedRows) => {
      setSelectedArticle(desings.find(obj => obj.id === record.id));
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
    },
    type: "radio"
  };
  const handleShowModalArticle = visible => setShowModalArticle(visible);

  const editClose = () => {
    setEdit(false);
  };

  const clickRow = row => {
    setSelectedRowKey([row.key]);
    setSelectedArticle(desings.find(obj => obj.id === row.id));
  };

  return edit ? (
    <Articulo desing={editDesingEl} back={true} close={editClose} />
  ) : (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col xl={16} lg={24}>
        <Table data={listOfArticles} columns={columns} rowSelection={rowSelection} onClick={() => clickRow} />
      </Col>
      <Col xl={8} lg={24}>
        <Card
          title={selectedArticle && selectedArticle.articleName}
          bodyStyle={{textAlign:'center'}}
          actions={[
            <span onClick={() => setShowModalArticle(true)}>
              <Icon type="eye" key="eye" /> {t('button.more_info')}
            </span>
          ]}
        >
          <img
            alt="Pieza"
            style={{ width: 353, height: 221, marginleft:'40%' }}
            src={selectedArticle && selectedArticle.figure === "eje" ?EjeFinal:RuedaFinal}
            />
          <RenderFigureData selectedArticle={selectedArticle} />
        </Card>
      </Col>
     <ArticleModal visible={showModalArticle} handleVisible={handleShowModalArticle} article={selectedArticle} />
    </Row>
  );
};

export default ListArticles;
